const TEXT="text"
export const GREEN ="success"
export const BLUE ="primary"
export const RED ="danger"
export const YELLOW ="warning"
export const WHITE = "light"
export const GREEN_TEXT = `${TEXT}-${GREEN}`
export const RED_TEXT = `${TEXT}-${RED}`
export const YELLOW_TEXT = `${TEXT}-${YELLOW}`
export const WHITE_TEXT = `${TEXT}-${WHITE}`